
import React, { useEffect, useState } from 'react';
import { Document, Page, pdf, View, Font } from '@react-pdf/renderer';

import { toast } from "react-toastify";
import {  pageStyle } from './reportCardStyles.js';
import { HeaderLogoSection, HeaderAddressSection, HeaderNameSection } from './headerSection.js';
import StudentSection from './studentSection.js';
import { ScoreSection } from './scoreSection.js';
import FooterSection from './footerSection.js';


Font.register({
  family: 'Calibri'
  , fonts: [{ src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibri.ttf" }
    , { src: "https://github.com/jondot/dotfiles/blob/master/.fonts/calibrib.ttf",
       fontWeight: "bold" }],
        format: 'truetype'
});

const ReportCardPDFAndroid = (props) => {

  const [lstReportCard, setLstReportCard] = useState([]);
  const [documentOpeningCalled, setDocumentLoadingCalled] = useState(false);


  useEffect(() => {
    // console.log("ReportCardPDFAndroid called");
    // console.log("props.lstReportCard in report cardpdf ", props.lstReportCard);
    // console.log("reportCard ", reportCard);
    setLstReportCard(props.lstReportCard);
    props.showLoader();
  }, [props.lstReportCard, props.teacherSignUrl]);

  const pages = [];

  
  const openDocument = async () => {
    // console.log("openDocument called");
    await setDocumentLoadingCalled(true);
    const document = await generateDocument();

    try {
        // Step 1: Generate the PDF Blob
        const blob = await pdf(document).toBlob();

        // Step 2: Check the file size (in bytes)
        const fileSizeInMB = blob.size / (1024 * 1024); // Size in MB

        // Define a threshold for the file size (for example, 10MB)
        const fileSizeThreshold = 10;

        if (fileSizeInMB > fileSizeThreshold) {
            // If file is too large, suggest downloading
            window.alert(`The file size is too large (${fileSizeInMB.toFixed(2)} MB). It may be slow to open. Downloading instead...`);

            // Force download if file is too large
            const downloadLink = document.createElement('a');
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = 'AnswerSheet.pdf';
            document.body.appendChild(downloadLink);
            downloadLink.click();
            document.body.removeChild(downloadLink);
        } else {
            // Step 3: Attempt to open the PDF in a new tab
            const fileURL = URL.createObjectURL(blob);
            const newTab = window.open(fileURL, '_blank');

            // Step 4: Check if the tab was successfully opened
            if (!newTab || newTab.closed || typeof newTab.closed === 'undefined') {
                window.alert('Popup blocked. Downloading file instead...');
                const downloadLink = document.createElement('a');
                downloadLink.href = fileURL;
                downloadLink.download = 'AnswerSheet.pdf'; // Set default filename
                document.body.appendChild(downloadLink);
                downloadLink.click();
                document.body.removeChild(downloadLink);
            }
        }
    } catch (error) {
        console.error('Error opening or downloading PDF:', error);
    }
    finally {
        props.hideLoader();
        props.closePdf();
    }
};

  const generateDocument = () => new Promise((resolve) => {
    const generatedDocument = (
      <Document>{pages}</Document>
    );
    resolve(generatedDocument);
  });


  for (let i = 0; i < lstReportCard.length; i++) {
    if (!lstReportCard[i]) {
      continue;
    }
    pages.push(
      <Page
        key={lstReportCard[i].studentSection.studentId}
        size="A4" style={pageStyle.page}>
        <View style={pageStyle.page_border}>
          <View style={pageStyle.header_section}>
            <View style={pageStyle.header_logo}>
              <HeaderLogoSection
                logoUrl={props.logoUrl}
                headerSection={lstReportCard[i].headerSection}
              />
            </View>
            <View style={pageStyle.header_address}>
              <HeaderAddressSection
                headerSection={lstReportCard[i].headerSection}
              />
            </View>
            <View style={pageStyle.header_name}>
              <HeaderNameSection
                headerName={lstReportCard[i].headerName}
              />
            </View>
          </View>
          <View style={pageStyle.student_section}>
            <StudentSection
              studentSection={lstReportCard[i].studentSection}
              clsSection={props.clsSection}
            />
          </View>
          <View style={pageStyle.score_section}>
            <ScoreSection
              scoreSection={lstReportCard[i].scoreSection}
              studentSection={lstReportCard[i].studentSection}
              rank={lstReportCard[i].rank}
              result={props.result}
            />
          </View>
          <View style={pageStyle.footer_section}>
            <FooterSection
              teacherSignUrl={props.teacherSignUrl}
              imageUrl={props.imageUrl}
              // flgValidated={props.flgValidated}
              flgValidated={true}
            />
          </View>
        </View>
      </Page>
    )
    if(i === lstReportCard.length-1 && !documentOpeningCalled){
      openDocument();
    }
  }
  
  
  return (
    <div  >
    </div>
  );
}

export default ReportCardPDFAndroid;

